import { OctTable } from "@oceantech/oceantech-ui";
import XMLViewer from "react-xml-viewer";
import { VIEW_TYPE, XML_ERROR_COLUMN, XML_TAB_CONFIG } from "./constants";
import { CODE, overflowHiddenTable } from "../../../utils/Constant";
import { XMLParser, XMLBuilder } from "fast-xml-parser";
import { useEffect, useState } from "react";
import { usePhanHeBaoHiemYTeContext, useXMLTabContext } from "../../contexts";
import { getXmlData } from "../../services";

type XmlViewerComponentProps = {
    xmlTabConfig: {
        code: string,
        urlData: string,
    };
}

const XmlViewerComponent = ({
    xmlTabConfig,
}: XmlViewerComponentProps) => {
    const [xmlData, setXmlData] = useState<string>("");
    const [columns, setColumns] = useState<any[]>([]);
    const [tableData, setTableData] = useState<any[]>([]);

    const { patientInfo } = usePhanHeBaoHiemYTeContext();
    const { validationErrors, viewType } = useXMLTabContext();

    const xmlValidationErrors = validationErrors?.[xmlTabConfig?.code];

    useEffect(() => {
        updateData();
    }, [xmlTabConfig]);

    useEffect(() => {
        if (!xmlValidationErrors) {
            return;
        }

		setTableData(
			tableData.map((row: any) => {
				const rowError = getXMLRowError(row, xmlValidationErrors);
				return {
					...row,
					errorMessage: rowError,
				};
			})
		);
	}, [xmlValidationErrors]);
    
    const getValueFromUrl = (data: any) => {
        let arrKey = xmlTabConfig.urlData?.split(".");
        let result = arrKey.reduce((key: any, item: any) => key[item], data);
        return Array.isArray(result) ? result : [result];
    };

    const updateData = async () => {
        try {
            let params = {
                patientCode: patientInfo?.patientCode || "",
                visitCode: patientInfo?.visitCode || "",
            };
            const { code, data } = await getXmlData(xmlTabConfig.code, params);
            
            if (CODE.SUCCESS === code && data) {
                const parser = new XMLParser({ ignoreAttributes: false, parseTagValue: false });
                let jsonObj = parser.parse(data);
                
                let _columns = Object.keys(getValueFromUrl(jsonObj)?.[0])?.map((item: string, index: number) => ({
                    name: item?.replace(/^\w/, (c) => c.toUpperCase()),
                    field: item,
                    cellStyle: {
                        minWidth: "50px",
                        maxWidth: "fit-content",
                        ...overflowHiddenTable,
                        ...(!index && { paddingLeft: "10px" })
                    },
                }));
                let _tableData = getValueFromUrl(jsonObj)?.map((item: any, index: number) => ({
                    ...item,
                    id: index,
                    errorMessage: getXMLRowError(item, xmlValidationErrors),
                }));

                setColumns([..._columns, ...XML_ERROR_COLUMN]);
                setTableData(_tableData);
            }

            setXmlData(data);
        } catch (error) {
            console.error(error);
        }
    };

    const generateXMLViewer = () => {
        switch (viewType) {
            case VIEW_TYPE.TAGS:
                return (
                    <XMLViewer xml={xmlData} collapsible theme={{
                        tagColor: "#3c78d8",
                        textColor: "#000",
                        separatorColor: "#aaa",
                    }} />
                );
            default:
                return (
                    <OctTable
                        className="h-100 table-background-th"
                        data={tableData ?? []}
                        columns={columns}
                        notDelete={true}
                        notEdit={false}
                        noToolbar={true}
                        fixedColumnsCount={-1}
                        isShowSelection={false}
                        clearToolbar={true}
                        noPagination
                        headerClasses="xml-table-view-header"
                        bodyClasses="xml-table-view-body"
                    />
                );
        }
    }

    const getXMLRowError = (rowData: any, errors: any[] = []) => {
        if (!errors.length) {
            return '';
        }

		const ERROR_MAPPER_FIELD = 'STT';
		const ERROR_MESSAGE_FIELD = 'ThongTinLoi';
        const DELIMITER = '\n';

		const errorMessageRows = errors.filter(
			(record) => record[ERROR_MAPPER_FIELD] === rowData[ERROR_MAPPER_FIELD]
		);

		if (!errorMessageRows.length) {
			return '';
		}

		return errorMessageRows.map((row) => row[ERROR_MESSAGE_FIELD]).join(DELIMITER);
	};

    return (
        <div className="spaces p-20 h-calc-vh-145 overflow-auto">
            {generateXMLViewer()}
        </div>
    );
};

export default XmlViewerComponent;
